import { useContext } from "react";
import InfrastructureContext from "contexts/Infrastructure.context";

export default function useInfrastructure() {
  const ctx = useContext(InfrastructureContext);

  if (!ctx) {
    throw new Error(
      "useInfrastructure must be used within InfrastructureContextProvider"
    );
  }

  return ctx;
}
